import { useEffect, useMemo } from "react";
import { TextInput } from "../../shared/Inputs/TextInput";
import SelectInput from "../../shared/Inputs/SelectInput";
import enumToOptions from "../../../utils/enumToOptions";
import { PaymentMethod } from "../../../models/HiddenPages";
import { HiddenPageProps } from "../HiddenPageSingle";
import HiddenPageForm from "../HiddenPageForm";

const depositTypeOptions = [
  { id: "percent", name: "Percent of the price" },
  { id: "fixed", name: "Fixed amount" },
];

export default function HiddenPaymentDetails({ register, setValue, watch }: HiddenPageProps) {
  const paymentMethodOptions = useMemo(() => enumToOptions(PaymentMethod), []);
  const depositEnabled = watch("defaults.depositEnabled");
  const depositType = watch("defaults.depositType");

  useEffect(() => {
    if (watch("defaults.depositEnabled") == null) setValue("defaults.depositEnabled", true);
    if (!watch("defaults.depositThreshold")) setValue("defaults.depositThreshold", "500");
    if (!watch("defaults.depositType")) setValue("defaults.depositType", "percent");
    if (!watch("defaults.depositPercent")) setValue("defaults.depositPercent", "5");
    if (!watch("defaults.depositFixed")) setValue("defaults.depositFixed", "50");
  }, [setValue, watch]);

  const schema = [
    { key: "bankAccountName", label: "Bank Account Name", type: "text" },
    { key: "accountNumber", label: "Account Number", type: "text" },
    { key: "sortCode", label: "Sort Code", type: "text" },
    {
      key: "paymentMethod",
      label: "Payment Method",
      type: "select",
      options: paymentMethodOptions,
      toggleableOptions: true,
    },
    { key: "company", label: "Company", type: "text" },
    { key: "vatNumber", label: "VAT Number", type: "text" },
  ];

  return (
    <>
      <HiddenPageForm
        title={"Payment Details"}
        description={"Fill out the payment details to prefill for this page."}
        register={register}
        setValue={setValue}
        watch={watch}
        schema={schema}
      />

      <div className="border-t pt-4 space-y-4">
        <div>
          <h3 className="text-sm font-semibold text-gray-900">Deposit</h3>
          <p className="text-xs text-gray-500 mt-1">
            Offer a deposit before collection when the seller enters their bank details and the price is at least the minimum.
          </p>
        </div>

        <label className="inline-flex items-center">
          <input
            type="checkbox"
            className="form-checkbox h-4 w-4 text-primary-600"
            {...register("defaults.depositEnabled")}
          />
          <span className="ml-2 text-sm text-gray-700">Offer a deposit</span>
        </label>

        {depositEnabled !== false && (
          <>
            <TextInput
              label="Minimum price (£)"
              register={register}
              registerName="defaults.depositThreshold"
              type="number"
            />
            <SelectInput
              label="Deposit amount"
              register={register}
              registerName="defaults.depositType"
              options={depositTypeOptions}
              setValue={setValue}
              watch={watch}
            />
            {depositType === "fixed" ? (
              <TextInput
                label="Fixed deposit (£)"
                register={register}
                registerName="defaults.depositFixed"
                type="number"
              />
            ) : (
              <TextInput
                label="Percent"
                register={register}
                registerName="defaults.depositPercent"
                type="number"
              />
            )}
          </>
        )}
      </div>
    </>
  );
}